// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "bc98253f" : chunkId) + "." + {"501":"7e63d871e474c3ee","2931":"e3f7c5c2427acadf","4199":"996548022517cc8c"}[chunkId] + ".js";
};